export default __webpack_public_path__ + "static/media/7457-harryleemedia.69f54e06.pdf";